export default {
  /**
   * 위험평가 항목 제안 결과 저장
   */
  SET_RISK_SUBTASKS(state, data) {
    state.riskSubtasks = data
  },

  /**
   * 재난 유형 정의 결과 저장
   */
  SET_RISK_TYPE(state, data) {
    state.riskType = data
  },

  /**
   * 현재 안전보건조치 제안 결과 저장
   */
  SET_CURRENT_SAFETY_MEASURES(state, data) {
    state.currentSafetyMeasures = data
  },

  /**
   * 현재 위험도 점수 제안 결과 저장
   */
  SET_CURRENT_RISK_POINT(state, data) {
    state.currentRiskPoint = data
  },

  /**
   * 위험감소대책 제안 결과 저장
   */
  SET_RISK_REDUCTIONS(state, data) {
    state.riskReductions = data
  },

  /**
   * 개선후 위험도 점수 제안 결과 저장
   */
  SET_AFTER_RISK_POINT(state, data) {
    state.afterRiskPoint = data
  },

  /**
   * 이미지 기반 위험성평가 분석 결과 저장
   */
  SET_IMAGE_RISK_ANALYSIS(state, data) {
    state.imageRiskAnalysis = data
  }
}
